<section>
  <h3 class="mat-headline">{{companyInformation.name}} Answers</h3>
  <mat-nav-list>
    <a mat-list-item *ngFor="let answer of answers" [routerLink]="answer.routerLink">{{answer.name}}</a>
  </mat-nav-list>
</section>
